import { render, staticRenderFns } from "./floors.vue?vue&type=template&id=63188c0d"
import script from "./floors.vue?vue&type=script&lang=js"
export * from "./floors.vue?vue&type=script&lang=js"
import style0 from "./floors.vue?vue&type=style&index=0&id=63188c0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports